import { render, staticRenderFns } from "./AllReturnReasons.vue?vue&type=template&id=c75f287a&"
import script from "./AllReturnReasons.vue?vue&type=script&lang=js&"
export * from "./AllReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./AllReturnReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c75f287a')) {
      api.createRecord('c75f287a', component.options)
    } else {
      api.reload('c75f287a', component.options)
    }
    module.hot.accept("./AllReturnReasons.vue?vue&type=template&id=c75f287a&", function () {
      api.rerender('c75f287a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/AllReturnReasons.vue"
export default component.exports